import { gql } from "@apollo/client";

export const UPDATE_BILLING_SUBSCRIPTION = gql`
  mutation UpdateBillingSubscription($input: SubscriptionUpdateV2Input!) {
    billingSubscriptionUpdateV2(input: $input) {
      status
    }
  }
`;
